const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
	brand: 'FFL Boss',
	year,
	copyright: '2011',
	productLink: 'https://admin.fflboss.com',
	reCAPTCHA: '6LcLpdYZAAAAAJ7GAGkirP1XxLYvy4DhHzg_SuT4',
	turnstile: (window.location.hostname === 'beta.admin.fflboss.com') ?
		'0x4AAAAAAEOYZTJ7QIR-vme-' :
		(window.location.hostname === 'admin.fflboss.com' ?
			'0x4AAAAAAEOYappwYWlRFdVv' :
			'0x4AAAAAAAXj52ltzefTqfQQ'),
	settings: {
		isDev: () => {
			return !process.env.production
		},
		apiURL: () => {
			//return 'https://va1.api.fflboss.com';
			return window.location.hostname === 'beta.admin.fflboss.com' ? "https://beta.api.fflboss.com" : (
				window.location.hostname === 'admin.fflboss.com' ?
					'https://va1.api.fflboss.com' :
					'https://dev.api.fflboss.com');
		},
		appURL: () => {
			return window.location.hostname === 'beta.admin.fflboss.com' ? "https://beta.fflboss.com" : (
				window.location.hostname === 'admin.fflboss.com' ?
					'https://app.fflboss.com' :
					'https://dev.fflboss.com');
		},
		apiVersion: 'v804'
	}
};

export default APPCONFIG;
